export const TRANSLATIONS_ES ={
 "header.home" : "Hogar" ,
 "header.admin" : "Administración" ,
 "header.analytic": "Analítica",
 "header.admin.users": "Usuarios",
 "header.admin.addUser": "Agregar Usuario",
 "header.admin.companies": "Empresas",
 "header.admin.subsidiary": "Subsidiarios",
 "header.admin.partner": "Proveedor",
 "header.admin.dept": "Departamentos de la empresa",
 "header.admin.loc": "Ubicaciones de la empresa",
 "header.admin.prod": "Productos",
 "header.admin.commodity": "Producto Básico",
 "header.admin.comprod": "Productos de la empresa",
 "header.admin.comsurv": "Encuesta de empresas",
 "header.admin.surveyprod": "Productos de encuesta",
 "header.admin.partnerDelegate": "Delegado Proveedor",
 "header.settings": "Ajustes",
 "header.settings.manageMFA": "Administrar MFA",
 "header.settings.enableMFA": "Habilitar MFA",
 "header.settings.disableMFA": "Deshabilitar MFA",
 "header.login": "Acceso",
 "header.logoff": "Desconectarse",
 "header.hello": "Hola",
 "header.admin.DelegateLocation":"Ubicación del Delegado de Proveedores",
 "header.admin.DelegateProduct":"Delegado de proveedor de productos",
 "header.admin.partnerDelegateAppSurvey":"Encuesta de la aplicación para Delegado de Proveedores",
 "header.admin.delegate":"Cadena de Suministro",
 "header.supply-chain":"Actualización de la cadena de suministro",
 "header.admin.supply-chain.display":"Mostrar cadena de suministro",
 "header.admin.neverLoggedInUsers":"Lista nunca conectado usuarios",
 "header.admin.users.neverLoggedIn":"Usuarios que nunca han iniciado sesión",
 "header.admin.supply-chain.edit":"Editar cadena de suministro",
 
 "page.option.mycompany": "Mi empresa",
 "footer.contactUs": "Contacta Con Nosotras",
 "footer.support": "Apoyo",
 "footer.emailUs": "Envíanos un email a",
 "page.select": "Seleccione un valor",
 "page.createAccount": "Crea tu Cuenta",
 "page.name": "Nombre",
 "page.email": "Correo Electrónico",
 "page.password": "Clave",
 "page.choosePassword": "Elegir una contraseña",
 "page.retypePassword": "Vuelva a escribir la contraseña",
 "page.address1": "Dirección Línea 1",
 "page.address2": "Dirección Línea 2",
 "page.city": "Ciudad",
 "page.country": "País",
 "page.state": "Estado",
 "page.zipCode": "Código postal",
 "page.zipExt": "Extensión postal",
 "page.phone": "Teléfono",
 "page.timezone": "Zona horaria",
 "page.language": "Idioma",
 "page.role": "Role",
 "page.interests": "Intereses",
 "page.appAccess": "Acceso a la aplicación",
 "page.application": "Aplicación",
 "page.subDate": "Fecha de suscripción",
 "page.addRow": "Insertar fila",
 "page.delRow": "Borrar fila",
 "page.active": "Activo",
 "page.active.not": "No Activo",
 "page.id": "Id",
 "page.status": "Estado",
 "page.MFAStatus": "MFA Estado",
 "page.action": "Acción",
 "page.address": "Dirección",
 "page.company": "Compañía",
 "page.userType": "Tipo de usuario",
 "page.subsidiary": "Subsidiario",
 "page.partner": "Empresa asociada",
 "page.buyer": "Comprador",
 "page.supplier": "Proveedor",
 "page.parentcompany": "Empresa matriz",
 "page.uom": "Unidad de medida",
 "page.latitude": "Latitud",
 "page.longitude": "Longitud",
 "page.contactName": "Nombre de contacto",
 "page.contactEmail": "Email de contacto",
 "page.companyURL": "Sitio web",
 "page.english": "Inglés",
 "page.spanish": "Español",
 "page.arabic": "Arábica",
 "page.turkish": "Turco",
 "page.serb.cyrl": "Serbio (cirílico)",
 "page.serb.latn": "Serbia (latina)",
 "page.french": "Francesa",
 "page.signup": "Sign up",
 "page.search": "Búsqueda",
 "page.clear": "Claro",
 "page.loading": "Cargando",
 "page.enabled": "Activado",
 "page.disabled": "Desactivado",
 "page.delete": "Borrar",
 "page.undelete": "Deshacer",
 "page.edit": "Editar",
 "page.multi.comp": "Es Multiempresa",
 "page.page": "Página",
 "page.goToPage": "Ir a la página",
 "page.openApp": " Abierta ",
 "page.of": "de",
 "page.submit": "Enviar",
 "page.cancel": "Cancelar",
 "page.upload": "Subir archivo",
 "page.answer": "Responder",
 "page.note": "Nota",
 "page.provisioning": "Aprovisionamiento",
 "page.generateRpt":"Encuesta de búsqueda",
 "page.add.note": "Agrega la nota",
 "page.add.response": "Agregar respuesta",
 "page.login": "Acceso",
 "page.questionnaire": "Cuestionario",
 "page.location":"Ubicación",
 "page.product":"Producto",
 "page.eval":"Evaluación",
 "page.eval.level":"Niveles de Evaluación",
 "page.high":"Alto",
 "page.medium":"Medio",
 "page.low":"Bajo",
 "page.ready":"Listo",
 "page.inspect":"Inspeccionar",
 "page.pause":"Pausa",
 "page.incomplete":"Incompleta",
 "page.green":"Verde",
 "page.yellow":"Amarilla",
 "page.orange":"Naranja",
 "page.chartType":"Tipo de gráfico",
 "page.locationcompany": "Compañía",
 "page.login.forgotPassword":"Has olvidado tu contraseña",
 "page.login.needHelp":"Necesitas ayuda?",
 "page.login.changePassword":"Cambia la contraseña",
 "page.login.verifyUser":"Verificar usuario",
 "page.login.sendCode":"Enviar nuevo código de verificación",
 "page.qrcodeScan":"Escanee el código QR que se muestra a continuación utilizando cualquier aplicación de autenticación como Google Authenticator, Microsoft Authenticator, etc.",
 "page.inputToken": "Ingrese el token del autenticador",
 "page.showDetails": "Mostrar detalles",
 "page.changePasswd.goBackTo":"Volver a",
 "page.changePasswd.oldPassword":"Contraseña anterior",
 "page.changePasswd.newPassword":"Nueva contraseña",
 "page.forgotPasswd.toResetPassword":"Para restablecer la contraseña",
 "page.forgotPasswd.step1":"1. Solicitud de un código de verificación que se enviará a su dirección de correo electrónico.",
 "page.forgotPasswd.step2":"2. Ingrese el código de verificación recibido junto con la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.step1.1":"Paso 1. Proporcione la identificación de correo electrónico registrada para generar un código de verificación.",
 "page.forgotPasswd.step1.2":"Verifique su correo electrónico para obtener el código de verificación después de enviar la solicitud.",
 "page.forgotPasswd.step2.1":"Paso 2. Ingrese el código de verificación enviado por correo electrónico y la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.verificationCode":"Código de verificación",
 "page.verification.verifyAccount":"Verifica tu cuenta",
 "page.verification.checkEmail":"Por favor revise su correo electrónico registrado para el código de verificación.",
 "page.resendCode.resend":"Vuelva a enviar el código de verificación",
 "page.manageMFA.token":"Se requiere ficha.",
 "page.MFAModel.header":"Proporcione un token de autenticación multifactor desde la aplicación Authenticator",
 "page.MFAModel.token":"Simbólico",
 "page.MFAModel.reset":"Restablecer autenticación multifactor",
 "page.editUser":"Editar usuario",
 "page.close":"Cerca",
 "page.pending":"Pendiente",
 "page.completed":"Terminado",
 "page.update":"Actualizar",
 "page.company.type":"Tipo de compañía",
 "page.company.name":"Nombre de Empresa",
 "page.company.group":"Grupo de empresas",
 "page.entity":"Entidad",
 "page.subsidiary.add": "Agregar subsidiaria",
 "page.partner.add": "Añadir acceso de comprador",
 "page.partner.edit": "Editar acceso del comprador",
 "page.buyer.add": "Agregar Comprador",
 "page.supplier.add": "Agregar Proveedor",
 "page.company.add": "Agregar Empresa",
 "page.company.edit": "Editar Empresa",
 "page.user.type": "Tipo de Usuario",
 "page.startDate": "Fecha de Inicio",
 "page.endDate": "Fecha final",
 "page.firstName": "Nombre de pila",
 "page.lastName": "Apellido",
 "page.dept":"Departamento",
 "page.dept.name":"Nombre de Departamento",
 "page.dept.type":"Tipo de departamento",
 "page.dept.add": "Agregar departamento",
 "page.dept.edit":"Departamento de edición",
 "page.description": "Descripción",
 "page.loc":"Ubicación",
 "page.loc.name":"Nombre del Ubicación",
 "page.loc.add": "Agregar Ubicación",
 "page.loc.edit":"Ubicación de edición",
 "page.process":"Proceso",
 "page.productGrp":"Grupo de productos",
 "page.commoName": "Nombre de la mercancía",
 "page.prodName": "Nombre del Producto",
 "page.prodNum": "SKU",
 "page.analytics": "Analítica",
 "page.prod": "Producto",
 "page.commodity": "Producto Básico",
 "page.lotcode": "Código de lote",
 "page.finishedLotCode": "Lote de producto terminado",
 "page.appAccess": "Acceso a la aplicación",
 "page.appSurvey": "Encuesta",
 "page.app.name": "aplicación",
 "page.survey.name": "Encuesta",
 "page.survey.review": "Revisión Requerida",
 "page.survey.share": "Compartir manualmente",
 "page.survey.addown": "Agregado por esta Empresa",
 "page.survey.addbuyer": "Añadido por el Comprador",
 "page.read": "Leer",
 "page.read.own": "lea Encuesta para Compradores",
 "page.read.medhigh": "Leer sólo puntuaciones altas",
 "page.write": "Escribir",
 "page.review": "Revisar",
 "page.read.sup": "Leer Encuesta de Proveedores",
 "page.write.sup": "Redactar Encuesta a Proveedores",
 "page.review.sup": "Revisar Encuesta a Proveedores",
 "page.corr.sup": "Encuesta a Proveedores de Action",
 "page.write.buy": "Escribir Encuesta de Proveedores",
 "page.review.buy": "Revisar la Encuesta de Proveedores",
 "page.write.own": "Escribe tu propia encuesta",
 "page.review.own": "Revisar la propia encuesta",
 "page.read.own": "Leer propia encuesta",
 "page.loc.buyer":"Ubicación del Comprador",
 "page.canTakeCorrectiveAction": "Acceso a Medidas Correctivas",
 "page.priority.buyer.score":"Prioridad a la puntuación del comprador",
 
 "page.oper.type":"Tipo de operación",
 "page.oper.area":"Área de operación",
 "page.oper.area.1":"Tipo",
 "page.oper.name":"Operación",
 "page.confirmationMessage": "Estas seguro?",
 "page.details":"Detalles",
 "page.option": "Opción",
 "page.subOption": "Sub Opción",
 "page.search.plc": "Búsqueda...",
 "page.harvest.lotscore": "Puntuación del lote de cosecha",
 "page.finish.lotscore": "Puntuación del lote terminado",
 "page.harvest.bol.abrv":"BL",
 "page.harvest.bol.assess":"Evaluación de BL",
 "page.harvest.bol":"Conocimiento de Embarque",
 "page.po.numscore": "Puntuación de orden de compra",
 "page.survey.alert": "Alerta de encuesta",
 "page.weekly": "Alerta Semanal",
 "page.monthly": "Alerta Mensual",
 "page.yearly": "Alerta Anual",
 "page.dow": "Día de la semana",
 "page.anyday": "Cualquier Día",
 "page.mon": "Lunes",
 "page.tue": "Martes",
 "page.wed": "Miércoles",
 "page.thu": "Jueves",
 "page.fri": "Viernes",
 "page.sat": "Sábado",
 "page.sun": "Domingo",
 "page.alert.notcomplete": "Alerta no Completada",
 "page.alert.complete": "Alerta Completa",
 "page.alert.highscore": "Alerta de Puntaje Alto",
 "page.analytics.name": "Nombre de análisis",
 "page.analytics.info": "Seleccione un tipo de análisis en el menú superior.",
 "page.farm.product" : "Puntuación de productos agrícolas",
 "page.productionDate": "Fecha de producción",
 "page.harvestDate": "Fecha de cosecha",
 "page.repackDate": "Fecha de Mezclar/Reenvasar",
 "page.score": "Puntaje", 
 "page.tracepo":"PO # / Trazabilidad #",
 "page.shipdate":"Fecha de Envío",
 "page.ship.assess":"Evaluación de envío",
 "page.prod.trend": "Análisis de Tendencias de Producción de SKU",
 "page.prod.raw": "Producto Crudo",
 "page.prod.finish": "Producto Terminado",
 "page.companyNumber": "Número de empresa",
 "page.suplrNumber": "Número de proveedor",
 "page.survey.canadd": "Comprador Agregar Encuesta",
 "page.broker.share": "Compartir la Encuesta Comprador",
 "page.provisioned.attribute": "Atributo aprovisionado",
 "page.provisioned.value": "Valor",
 "page.change.analytics": "Análisis de Cambios",
 "page.multi.product": "Producto múltiple",
 "page.HepA.vaccination.rate": "Tasa de vacunación contra la Hepatitis-A",
 "page.water.source": "Fuente de agua",
 "page.unknown": "Desconocida",
 "page.water.equip.clean": "Fuente de agua para limpieza de equipos",
 "page.water.fruit.clean": "Agua de lavado de frutas",
 "page.worker.regional.location": "Nacionalidad del trabajador/ubicación regional",
 "page.housing.density": "Densidad de vivienda",
 "page.human.biosolid.use": "Uso de biosólidos humanos en granja",
 "page.waste.treatment": "Tratamiento de residuos",
 "page.water.potable": "El agua es potable?",
 "page.HepA.vaccination": "Vacunación contra la hepatitis A",
 "page.freq": "Frecuencia",
 "page.deviceAccess": "Acceso al dispositivo",
 "page.yes": "Sí",
 "page.no": "No",
 "page.secondarySupplierName": "Nombre del proveedor secundario",
 "page.farm.annual.assessments":"Evaluaciónes Anual de la Granja",
 "page.facility.annual.assessments":"Evaluaciónes anual de la instalación",
 "page.finished.product.assessments":"Evaluaciónes del producto terminado",
 "page.shipment.assessments":"Evaluaciones de envío",
 "page.facilities":"Instalaciones",
 "page.facility":"Instalación",
 "page.prod.assess":"Evaluaciones de producción",
 "page.inc.assess":"Evaluaciones de productos entrantes",
 "page.corr.action":"Acciones correctivas",
 "page.grower":"Productores",
 "page.harvest.assess":"Evaluaciones de cosecha",
 "page.level":"Nivel",
 "page.parentSupplierName":"Proveedor principal",
 "page.next":"Próximo",
 "page.back":"Atrás",
 "page.delete.details":"Eliminar detalles",
 "page.setDates":"Establecer fechas",
 "page.supplier.dates":"Fechas del proveedor",
 "page.dates.access":"Fechas de Acceso",
 "page.supplyChain": "Cadena de suministro",
 "page.take.corr.action": "Tomar acciones correctivas",
 "page.completed.corr.action": "Acciones correctivas completadas",
   
 "error.MFATokenError": "El token de autenticación multifactor proporcionado no es válido.",
 "error.MFAAuthFailed": "La autenticación multifactor falló ",
 "error.MFAStateError": "Hubo un error al cambiar el estado de MFA.",
 "error.error": "Error : ",
 "error.system.fetch": "Se produjo un error de aplicación, los datos no se recibido",
 "error.system.update": "Se produjo un error de aplicación, los datos no se actualizaron",
 "error.userAuthFailed":"Autenticación de usuario fallida",
 "error.userReqd":"Se requiere una identificación de usuario",
 "error.emailReqd":"Correo electronico es requerido",
 "error.passwdReqd":"Se requiere contraseña",
 "error.changePasswordFailed":"Cambio de contraseña falló. Por favor, inténtelo de nuevo más tarde",
 "error.invalidEmail":"Proporcione una identificación de correo electrónico válida",
 "error.oldPasswdReqd":"Se requiere contraseña antigua",
 "error.weakPassword":"Elija una contraseña segura con un mínimo de 8 caracteres, un número y un carácter especial",
 "error.sendCodeError":"Error al enviar el código de verificación para restablecer la contraseña. Por favor, inténtelo de nuevo más tarde",
 "error.codeReqd":"Se necesita un código de verificación",
 "error.verificationFailed":"Fallo en la verificación. Por favor, inténtelo de nuevo más tarde",
 "error.resendVerificationFailed":"Error al reenviar el código de verificación. Por favor, inténtelo de nuevo más tarde",
 "error.MFASetupFailed":"La autenticación multifactor no se puede configurar actualmente",
 "error.tokenVerifyFailed":"La verificación del token falló. Por favor, inténtelo de nuevo más tarde",
 "error.MFAStateChangeFailed":"Hubo un error al cambiar el estado de MFA.",
 "error.unhandledException":"Tipo de acción no controlada",
 "error.userListNotRetrieved":"No se recuperó la lista de usuarios",
 "error.userDeleteFailed":"Eliminación de usuario fallida",
 "error.getInterestFailed":"No se recuperó la lista de intereses",
 "error.getRoleFailed":"No se recuperó la lista de funciones",
 "error.getAppNamesFailed":"No se recuperó la lista de nombres de aplicaciones",
 "error.getTimezoneFailed":"No se recuperó la lista de zonas horarias",
 "error.getStateFailed":"No se recuperó la lista de estados",
 "error.getCountryFailed":"La lista de países no fue recuperada",
 "error.getUOMFailed":"La lista de la unidad de medida no se pudo recuperar",
 "error.getUserSubTypeFailed":"No se pudo recuperar la lista de subtipo de usuario",
 "error.getDeptTypeFailed":"La lista de tipos de departamento no se pudo recuperar",
 "error.getProcessNamesFailed":"La lista de nombres del proceso no se pudo recuperar",
 "error.getProdGrpFailed":"La lista de grupos de productos no se pudo recuperar",
 "error.getProdFailed":"La lista de productos no se pudo recuperar",
 "error.userNameReqd":"Se requiere nombre de usuario",
 "error.firstNameReqd":"Se requiere el primer nombre",
 "error.lastNameReqd":"Se requiere apellido",
 "error.userTypeReqd":"Se requiere el tipo de usuario",
 "error.stateReqd":"Se requiere estado",
 "error.countryReqd":"El país es obligatorio",
 "error.interestReqd":"Se requiere interés",
 "error.userEditFailed":"La información del cliente no se actualizó",
 "error.addUserFailed":"Nuevo cliente no fue agregado",
 "error.verifyEmail":"El usuario debe verificar la dirección de correo electrónico utilizando el código de verificación enviado por correo electrónico",
 "error.retypePasswdReqd":"Se requiere volver a escribir la contraseña",
 "error.passwdMatchFailed":"Las contraseñas no coinciden",
 "error.companyListNotRetrieved":"No se recuperó la lista de empresas",
 "error.companyDeleteFailed":"Eliminación de empresa fallida",
 "error.getCompanyTypeFailed":"No se recuperó la lista de tipos de empresa",
 "error.getCompanyGroupFailed":"No se recuperó la lista Grupo de empresas",
 "error.getEntityFailed":"La lista de entidades no fue recuperada",
 "error.companyNameReqd":"El nombre de la empresa es obligatorio",
 "error.companyTypeReqd":"El tipo de empresa es obligatorio",
 "error.companyEditFailed":"La información de la empresa no se actualizó",
 "error.companyReqd":"Se requiere empresa",
 "error.appName.Reqd":"El nombre de la aplicación son obligatorios",
 "error.appName.appRole.Reqd":"El nombre de la aplicación y el rol de la aplicación son obligatorios",
 "error.only1RowAllowed":"Solo puede agregar 1 fila a la vez",
 "error.appAccessDup":"Acceso para Aplicación ya presente",
 "error.appAccessEditFailed":"No se pudo editar el acceso a la aplicación",
 "error.newRowAdded":"Ya se agregó una nueva fila",
 "error.subsidiaryNotRetrieved":"No se encontró una lista de subsidiarias",
 "error.subsidiaryReqd":"Se debe seleccionar la subsidiaria de otra manera cancelar la solicitud haciendo clic en Cerrar",
 "error.subsidiaryDeleteFailed":"La actualización de los datos subsidiarios fracasó",
 "error.partnerNotRetrieved":"La lista de proveedores no se pudo recuperar",
 "error.partnerReqd":"Se debe seleccionar la empresa cliente de otra manera cancelar la solicitud haciendo clic en Cerrar",
 "error.startdateReqd":"La fecha de inicio es obligatoria",
 "error.partnerDeleteFailed":"La eliminación del proveedor falló",
 "error.deptTypeReqd":"El tipo de departamento es obligatorio",
 "error.deptNameReqd":"Se requiere el nombre del departamento",
 "error.deptNotRetrieved":"La lista de departamento no se pudo recuperar",
 "error.deptReqd":"Se debe seleccionar el departamento de otra manera Cancelar la solicitud haciendo clic en Cerrar",
 "error.deptDeleteFailed":"El departamento no pudo ser eliminado",
 "error.deptEditFailed":"La información del departamento no se pudo actualizar",
 "error.userDeptEditFailed":"El cambio de departamento falló",
 "error.userDeptDup":"El departamento ya está presente",
 "error.locNameReqd":"Se requiere el nombre de la ubicación",
 "error.locNotRetrieved":"La lista de ubicaciones no se pudo recuperar",
 "error.locReqd":"Se debe seleccionar la ubicación de lo contrario Cancelar la solicitud haciendo clic en Cerrar",
 "error.locDeleteFailed":"La ubicación no se pudo eliminar",
 "error.locEditFailed":"La información de ubicación no se pudo actualizar",
 "error.deptProcDup":"El proceso ya está presente",
 "error.deptProcDeleteFailed":"El proceso no se pudo eliminar",
 "error.deptProcEditFailed":"La modificación del proceso del departamento falló",
 "error.deptProc.Reqd":"Se requiere un proceso",
 "error.searchProdInvalid":"Seleccione el grupo de productos o proporcione un mínimo de 3 letras de nombre del producto para buscar",
 "error.prodEditFailed":"modificación del Producto falló",
 "error.commoEditFailed":"Modificar la información de productos básicos falló",
 "error.prodGrp.Reqd":"Se requiere un grupo de productos",
 "error.prodDup":"El producto ya está presente",
 "error.prodName.Reqd":"Se requiere el nombre del producto",
 "error.commoName.Reqd":"Se requiere el nombre de la mercancía",
  "error.commodityKey.Reqd":"Se requiere materia prima",
 "error.userGetProdFailed":"La lista de productos para el usuario no se pudo recuperar",
 "error.userProdEditFailed":"Modificación del Producto falló",
 "error.locDup":"La ubicación ya está presente",
 "error.userGetLocFailed":"Lista de ubicación para el usuario no se pudo recuperar",
 "error.userLocEditFailed":"Modificar la ubicación falló",
 "error.sessionTimeout":"Se ha agotado el tiempo de sesión. Por favor inicie sesión nuevamente.",
 "error.logoutFailed":"Error al cerrar sesión.",
 "error.appSurveyNameReqd":"Se requiere la aplicación y la encuesta",
 "error.getAppSurveyFailed":"La lista de nombres de encuestas no se pudo recuperar",
 "error.userGetAppSurveyFailed":"No se pudo recuperar la lista de encuestas para el usuario",
 "error.compGetAppSurveyFailed":"No se pudo recuperar la lista de encuestas de la empresa",
 "error.userAppSurveyEditFailed":"La modificación del acceso a la encuesta de la aplicación falló",
 "error.userAppSurveyDup":"La encuesta de la aplicación ya está presente, actualice la entrada existente",
 "error.partnerGetAppSurveyFailed":"No se pudo recuperar la lista de encuestas de las empresas asociadas",
 "error.partnerAppSurveyEditFailed":"La modificación del acceso a la encuesta de la aplicación falló",
 "error.partnerAppSurveyDup":"La encuesta de la aplicación ya está presente, actualice la entrada existente",
 "error.operTypeReqd":"Se requiere el tipo de operación",
 "error.operAreaReqd":"Se requiere un área de operación",
 "error.userGetPartnerFailed":"No se pudo recuperar la lista de proveedores para el usuario",
 "error.userPartnerEditFailed":"Modificar el acceso al proveedor falló",
 "error.userPartnerDup":"El proveedor ya está presente, actualice la entrada existente",
 "error.endDateBeforeStartDate":"La fecha de finalización es anterior a la fecha de inicio",
 "error.userGetSubsidiaryFailed":"No se pudo recuperar la lista de subsidiarias del usuario",
 "error.userSubsidiaryEditFailed":"Error al modificar el acceso a la subsidiaria",
 "error.userSubsidiaryDup":"La subsidiaria ya está presente; actualice la entrada existente",
 "error.suplrReqd":"Se requiere proveedor",
 "error.partnerGetAppSurveyFailed":"La lista de encuestas de aplicaciones para el usuario y el proveedor no se pudo recuperar",
 "error.partnerGetDepartmentFailed":"La lista de departamentos para el usuario y el proveedor no se pudo recuperar",
 "error.partnerGetLocFailed":"La lista de ubicación para el proveedor no se pudo recuperar",
 "error.partnerGetProdFailed":"La lista de productos para el proveedor no se pudo recuperar",
 "error.partnerGetSurveyAlertFailed":"La lista de alertas para el proveedor no se pudo recuperar",
 "error.subsidiaryGetAppSurveyFailed":"No se pudo recuperar la lista de encuestas de aplicaciones para usuarios y subsidiaria",
 "error.subsidiaryGetDepartmentFailed":"No se pudo recuperar la lista de departamentos para usuarios y subsidiaria",
 "error.subsidiaryGetLocFailed":"No se pudo recuperar la lista de ubicación para usuarios y subsidiaria",
 "error.subsidiaryGetProdFailed":"No se pudo recuperar la lista de productos para usuarios y subsidiaria",
 "error.userGetSurveyAlertFailed":"No se pudo recuperar la lista de alertas para el usuario",
 "error.userSurveyAlertEditFailed":"Error al modificar la alerta de la encuesta",
 "error.userSurveyAlertDup":"La alerta de encuesta ya está presente; actualice la entrada existente",
 "error.getAnalyticsFailed":"No se pudo recuperar la lista de análisis",
 "error.userGetAnalyticsFailed":"No se pudo recuperar la lista de análisis de este usuario",
 "error.Analytics.NoSurvey":"Encuestas no encontradas para el proveedor",
 "error.userAnalyticsEditFailed":"Error al modificar el acceso a análisis",
 "error.userAnalyticsDup":"Analytics ya está presente; actualice la entrada existente",
 "error.analyticsNameReqd":"Se requiere análisis",
 "error.analytics.nodata": "Datos no encontrados para los criterios de búsqueda",
 "error.provNotRetrieved": "No se pudo recuperar el aprovisionamiento de usuarios",
 "error.userProvEditFailed": "Error al modificar el aprovisionamiento de usuarios",
 "error.attributeReqd": "El atributo es obligatorio",
 "error.duplicate.attribute": "Atributo ya aprovisionado",
 "error.getLocationProvisionFailed":"No se pudo recuperar la lista de provisiones de ubicación de empresa",
 "error.hepA.float":"El porcentaje de vacunación contra la hepatitis A debe ser un número decimal",
 "error.phoneReqd": "Se requiere el número de teléfono para acceder al dispositivo",
 "error.getSurveyListFailed":"No se pudo recuperar la lista de encuestas",
 "error.survey.Reqd":"Se requiere encuesta",
 "error.prod.Reqd":"Se requiere producto",
 "error.supplierListNotRetrieved":"No se pudo recuperar la lista de proveedores",
 "error.supplier.Reqd":"Se requiere proveedor",
 "error.buyer.Reqd":"Se requiere comprador",
 "error.partnerDelegateNotRetrieved":"Delegado de proveedores no se pudo recuperar",
 "error.partnerDelegateDeleteFailed":"Error al eliminar el delegado de proveedores",
 "error.partnerDelegateDup":"Delegado del proveedor ya está presente",
 "error.partnerDelegateSaveFailed":"Delegado del proveedor no se pudo guardar",
 "error.invalid.delegate.relation":"El comprador y el delegado no pueden ser iguales",
 "error.indirectBuyer.Reqd":"Se requiere comprador indirecto",
 "error.delegateLocationNotRetrieved":"No se pudo recuperar la ubicación del delegado",
 "error.delegateLocationDeleteFailed":"La ubicación del delegado no se pudo eliminar",
 "error.delegateLocationDup":"Ubicación del delegado ya aprovisionada",
 "error.delegateLocKey.Reqd":"Se requiere la clave de ubicación del delegado",
 "error.delegateLocationSaveFailed":"No se pudo guardar la ubicación del delegado",
 "error.delegateProductNotRetrieved":"No se pudo recuperar el producto del delegado",
 "error.delegateProductDeleteFailed":"Error en la eliminación del producto delegado",
 "error.delegateProductDup":"Producto delegado ya aprovisionado",
 "error.delegateProdKey.Reqd":"Producto delegado no encontrado para actualización",
 "error.delegateProductSaveFailed":"No se pudo guardar el producto delegado",
 "error.onlyEditAllowed":"Guardar/Cancelar la operación de edición",
 "error.location.Reqd":"Se requiere ubicación",
 "error.partnerNumber.invalid":"Número de socio no válido. Sólo se permiten caracteres alfanuméricos y _, -",
 "error.delegateAppSurveyNotRetrieved":"No se pudo recuperar la encuesta de la aplicación de delegados",
 "error.delegateAppSurveyDeleteFailed":"Error al eliminar la encuesta de la aplicación Delegate",
 "error.delegateAppSurveyDup":"Encuesta de la aplicación para delegados ya aprovisionada",
 "error.surveyDelegateKey.Reqd":"Encuesta de la aplicación de delegados no encontrada para actualización",
 "error.delegateAppSurveySaveFailed":"No se pudo guardar la encuesta de la aplicación Delegate",
 "error.parentSupplierNotRetrieved":"No se pudo recuperar el proveedor principal",
 "error.invalid.parent.child.relation":"El proveedor secundario no puede ser el mismo que el proveedor principa",
 "error.parentSupplier.Reqd":"Se requiere proveedor principal",
 "error.delegateKeyReqd":"Se requiere delegado",
 "error.userDelegateNotRetrieved":"No se pudo recuperar el delegado de usuario",
 "error.userDelegateDeleteFailed":"Error de eliminación de delegado de usuario",
 "error.userDelegateDup":"El delegado de usuario ya está presente",
 "error.userDelegateSaveFailed":"No se pudo guardar el delegado de usuario",
 "error.userDelegateEditFailed":"Error al modificar el delegado de usuario",
 "error.delegateNotRetrieved":"El delegado no pudo ser recuperado",
 "error.delegateGetAppSurveyFailed":"No se pudo recuperar la lista de encuestas de aplicaciones para usuarios y delegados.",
 "error.userDelegateKeyReqd":"Se requiere delegado de usuario",
 "error.delegateGetLocationFailed":"No se pudo recuperar la lista de ubicaciones del usuario y del delegado",
 "error.delegateGetProductFailed":"No se pudo recuperar la lista de productos para el usuario y el delegado",
 "error.onlyOneOpAllowed":"Sólo se permite una operación",
 "error.userDetailsDeleteFailed":"Error al eliminar los detalles del usuario",
 "error.partnerGetDateFailed":"No se pudo recuperar la lista de fechas del proveedor.",
 "error.partnerDateEditFailed":"Falló la modificación de la fecha del proveedor.",
 "error.datesOverlap":"Fechas superpuestas",
 "error.buyerListNotRetrieved":"No se pudo recuperar la lista de compradores",
 "error.neverLoggedInUsersNotRetrieved":"No se pudo recuperar la lista de usuarios que nunca iniciaron sesión",
 "error.rowNotSelected":"Seleccione la casilla de verificación en la fila donde se deben agregar datos.",
 "error.buyerNotSelected":"Compradoras no seleccionadas",
 "error.supplyChainEditFailed":"Error al añadir compradores a la cadena de suministro.",
 
 "confirm.delete.details":"¿Está seguro de que desea eliminar las disposiciones de usuario?",
 "confirm.change.user.company":"La empresa usuaria solo se puede cambiar después de eliminar las disposiciones del usuario. ¿Está seguro de que desea eliminar las disposiciones de usuario?",
 
 "info.success.stored": "La información se ha almacenado correctamente.",
}